import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import * as styles from './position-profile-matching-criteria.module.scss';
import { BasicButton, BasicTable } from '../../../assets/common';
import positionProfileApi from '../../../services/positionProfileApi';
import { Spin } from 'antd';
import PopoutSetName from '../../Admin/SPManagement/ManagingCriteriaCP/ManualRunStatus/DataTable/PopoutSetName/PopoutSetName';
import { useSelector } from 'react-redux';
import { adminApi } from '../../../services/admin';

const PositionProfileMatchingCriteria = ({ positionCode }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  //View Matching Criteria State
  const [popoutSetName, setPopoutSetName] = useState(null);
  const [currentSetDetail, setCurrentSetDetail] = useState(null);
  const roleActive = useSelector((state) => state.user.roleActive);

  const getData = useCallback(async () => {
    if (!positionCode) return;
    try {
      setLoading(true);
      const res = await positionProfileApi.getMatchingCriteria(positionCode);
      if (res.status === 200) {
        setData(res.data.result);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [positionCode]);

  const fetchSetMatchingDetails = async (run_id) => {
    try {
      setLoading(true);
      const res = await adminApi.getSetMatchingDetails(roleActive.roleId, run_id);
      if (res.status === 200) {
        setCurrentSetDetail(res.data.result);
        setPopoutSetName(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewMatchingCriteria = (record) => {
    fetchSetMatchingDetails(record.run_id);
  };

  const handleViewRecommendation = (record) => {
    window.open(`/admin/sp-management/view-result-matching/${positionCode}/${record.run_id}?type=manual`);
  };

  const COLUMNS = useMemo(
    () => [
      {
        title: 'Matching Criteria Set',
        render: (_, item) => (
          <div className={styles.criteriaTitle}>
            <span>
              Set {item.set_number}: {item.name}
            </span>
            {item.is_main && <span className={styles.mainLabel}>Main</span>}
          </div>
        ),
      },
      {
        title: 'Matching Criteria',
        width: '33%',
        render: (_, item) => (
          <BasicButton mode="teal" onClick={() => handleViewMatchingCriteria(item)} disabled={!item.is_enable_matching}>
            View Matching Criteria
          </BasicButton>
        ),
      },
      {
        title: 'Master Sheet',
        width: '33%',
        render: (_, item) => (
          <BasicButton mode="teal" onClick={() => handleViewRecommendation(item)} disabled={!item.is_enable_bestfit}>
            View Recommendation
          </BasicButton>
        ),
      },
    ],
    []
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Spin spinning={loading}>
      <div className={styles.wrapper}>
        <div className={styles.title}>Matching Criteria</div>
        <div className={styles.tableContainer}>
          <BasicTable
            rowKey="id"
            styles={{
              headerColor: '#8896A7',
              headerWeight: 700,
              borderRadius: 6,
            }}
            dataSource={data}
            columns={COLUMNS}
            pagination={false}
          />
        </div>
        {popoutSetName && <PopoutSetName popoutSetName={true} setPopoutSetName={setPopoutSetName} currentSetDetail={currentSetDetail} />}
      </div>
    </Spin>
  );
};

export default PositionProfileMatchingCriteria;

PositionProfileMatchingCriteria.propTypes = {
  positionCode: PropTypes.string,
};
